import List from 'modules/Tickets/List/List'
import Sagas from 'modules/Tickets/List/saga'
import Reducer from 'modules/Tickets/List/reducer'

export default List

export { Sagas, Reducer }
